<template>
  <div class="card">
    <div class="card-body">
      <div class="row">
        <div class="row">
          <div class="col-lg-12 d-flex flex-wrap">
            <div class="mx-1">
              <p class="text-center">Gösterilen Kayıt Sayısı</p>
              <v-btn-toggle mandatory solo dense>
                <v-btn @click="perPage = 10"> 10</v-btn>
                <v-btn @click="perPage = 20"> 20</v-btn>
                <v-btn @click="perPage = 30"> 30</v-btn>
                <v-btn @click="perPage = 50"> 50</v-btn>
                <v-btn @click="perPage = 100"> 100</v-btn>
              </v-btn-toggle>
            </div>
            <div class="ms-auto">
              <v-text-field
                  v-model="searchText"
                  class="mt-5 pt-3"
                  outlined
                  rounded
                  dense
                  placeholder="Arama Yapın..."
                  clearable
                  hide-details
                  append-icon="mdi-magnify"
                  @click:append="searchListWithText()"
                  @keydown.enter="searchListWithText()"
              ></v-text-field>
            </div>
          </div>
          <div class="d-flex justify-content-between">
            <ExcelExport
                :dataProp="projectList"
                :column-prop="projectListHeaders"
                :fileNameProp="'Proje Listesi'"
            >

            </ExcelExport>
            <v-btn small color="success darken-1 me-6" @click="openNewProjectDialog">Proje Oluştur</v-btn>
          </div>
          <div>
          </div>
        </div>
        <div class="row">
          <ResultTableView></ResultTableView>
        </div>
        <!-- end row -->
        <div class="row">
          <div class="col-lg-12 mb-5">
            <v-pagination
                v-model="currentPage"
                class="my-4"
                :length="projectListMetaData.totalPages"
                :total-visible="10"
            ></v-pagination>
          </div>
        </div>
      </div>
    </div>
    <NewProjectDialog
        :showDialog="newProjectDialog"
        :processType="'new'"
        @dialogChange="(e) => (newProjectDialog = e)"
    ></NewProjectDialog>
  </div>

</template>

<script>
import ResultTableView from "@/components/project/results/ResultsTableView";
import {mapState, mapActions} from "vuex";
import NewProjectDialog from "@/components/project/dialogs/NewProjectDialog.vue";
import {showProcessErrorMessage} from "@/state/alertHelpers";
import ExcelExport from "@/components/shared/ExcelExport.vue";

export default {
  components: {
    ExcelExport,
    NewProjectDialog,
    ResultTableView,
  },
  created() {
    this._fetchProjectList();
  },
  computed: {
    ...mapState("project", ["projectList", "projectListMetaData","projectListHeaders"]),
    ...mapState("auth", ["user"]),
    ...mapState("cart", ["current"]),
  },
  data() {
    return {
      dataView: "ResultTableView",
      perPage: 10,
      currentPage: 1,
      searchText: "",
      newProjectDialog: false,
    };
  },
  methods: {
    ...mapActions("project", ["fetchProjectList"]),
    async _fetchProjectList() {
      await this.fetchProjectList({
        params: {
          userId: this.user.UserId,
          pageNumber: this.currentPage,
          pageSize: this.perPage,
        },
        body: {},
      })
    },
    openNewProjectDialog() {
      if (this.current === null) {
        showProcessErrorMessage(({
          title: "İşlem Başarısız",
          text: "Önce Cari Seçmelisiniz.",
        }));
        return;
      }
      this.newProjectDialog = true;
    },
    searchListWithText() {
      this.fetchProjectList({
        params: {
          userId: this.user.UserId,
          pageNumber: 1,
          pageSize: this.perPage,
          ...(this.user.RoleGroupId == "2" || this.user.RoleGroupId == 2 ? true : false) && {salesPersonCode: this.user.SalesPersonCode},
          ...(this.searchText == "" || this.searchText == null ? false : true) && {searchText: this.searchText}
        },
        body: {}
      });
    }
  },
  watch: {
    perPage: function (newVal) {
      this.fetchProjectList({
        params: {
          userId: this.user.UserId,
          pageNumber: 1,
          pageSize: newVal,
          ...(this.user.RoleGroupId == "2" || this.user.RoleGroupId == 2 ? true : false) && {salesPersonCode: this.user.SalesPersonCode},
          ...(this.searchText == "" || this.searchText == null ? false : true) && {searchText: this.searchText}
        },
        body: {}
      });
      this.currentPage = 1;
    },
    currentPage: function (newVal) {
      this.fetchProjectList({
        params: {
          userId: this.user.UserId,
          pageNumber: newVal,
          pageSize: this.perPage,
          ...(this.user.RoleGroupId == "2" || this.user.RoleGroupId == 2 ? true : false) && {salesPersonCode: this.user.SalesPersonCode},
          ...(this.searchText == "" || this.searchText == null ? false : true) && {searchText: this.searchText}
        },
        body: {}
      });
    },
  },
};
</script>